<template>
	<div>
		<h3>员工设置</h3>
		<el-button type="primary" size="small" @click="centerDialogVisible=true;title='添加员工';ruleForm2={name: '',passport: '',password: ''}">添加员工</el-button>
		<span class="red">在这里添加的员工，只能在 <a class="blue" href="http://www.dajiuxing.com.cn/salesSystem/#/login">http://www.dajiuxing.com.cn/salesSystem/#/login</a> 登录</span>
		<div class="table">
			<el-table :data="tableData4" style="width: 100%" height='calc(100vh - 300px)' border>
				<el-table-column prop="user.name" label="姓名"></el-table-column>
				<el-table-column prop="user.passport" label="账号"></el-table-column>
				<!-- <el-table-column prop="password" label="密码"></el-table-column> -->
				<el-table-column label="操作" align='center'>
					<template slot-scope="scope">
						<el-button type="text" @click="centerDialogVisible=true;title='修改信息';ruleForm2=scope.row.user;setruleForm3(scope.row.plst)">修改信息</el-button>
						<template v-if="scope.row.user.level == 0">
							<el-button type="text" disabled>删除员工</el-button>
						</template>
						<template v-else>
							<el-button type="text" @click='centerDialogVisible2=true;ruleForm2=scope.row'>删除员工</el-button>
						</template>
						
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<el-pagination class='pagination' @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40]"
			 :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="allpage">
			</el-pagination>
		</div>
		<!-- //添加员工 -->
		<el-dialog :title="title" :visible.sync="centerDialogVisible"  center>

			<el-form :model="ruleForm2" status-icon :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
				<el-form-item label="姓名:" prop="name">
					<el-input v-model="ruleForm2.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="账号:" prop="passport">
					<el-input v-if="title == '添加员工'" v-model="ruleForm2.passport" autocomplete="off"></el-input>
					<el-input v-else v-model="ruleForm2.passport" autocomplete="off" disabled></el-input>
				</el-form-item>
				<el-form-item label="密码" prop="password">
					<el-input v-model.number="ruleForm2.password"></el-input>
				</el-form-item>
			</el-form>
			<el-form :model="ruleForm3" label-width="150px" label-position="left" style='margin-left: 60px;'>
				<el-form-item label="店铺:">
					<el-switch v-model="ruleForm3.value1" active-text="查看权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
					<el-switch v-model="ruleForm3.value2" active-text="操作权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
				</el-form-item>
				<el-form-item label="商品管理:">
					<el-switch v-model="ruleForm3.value3" active-text="查看权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
					<el-switch v-model="ruleForm3.value4" active-text="操作权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
				</el-form-item>
				<el-form-item label="财务管理:">
					<el-switch v-model="ruleForm3.value5" active-text="查看权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
					<el-switch v-model="ruleForm3.value6" active-text="操作权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
				</el-form-item>
				<el-form-item label="设置:">
					<el-switch v-model="ruleForm3.value7" active-text="查看权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
					<el-switch v-model="ruleForm3.value8" active-text="操作权限" active-color="#13ce66" inactive-color="#ff4949" :disabled="disabledStatus"></el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;getData()">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm2')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="删除人员" :visible.sync="centerDialogVisible2" width='400px'  center>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible2 = false">取 消</el-button>
				<el-button type="primary" @click="deleteFun('ruleForm2')">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { addsub,listsubBySetter,delsub,addPermission } from '@/axios/api.js'
	export default {
		data() {
			var checkAge = (rule, value, callback) => {
				if(this.title == '修改信息') return callback();
				if (!value) {
					return callback(new Error('请输入密码！'));
				} else {
					if(value.toString().length < 6){
						return callback(new Error('密码不能少于6位！'));
					}
					callback();
				}
			};
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入姓名！'));
				} else {
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入账号！'));
				} else {
					callback();
				}
			};
			return {
				ruleForm2: {name: '',passport: '',password: ''},
				ruleForm3: {
					value1: false,
					value2: false,
					value3: false,
					value4: false,
					value5: false,
					value6: false,
					value7: false,
					value8: false,
				},
				rules2: {
					name: [{
						validator: validatePass,
						trigger: 'blur'
					}],
					passport: [{
						validator: validatePass2,
						trigger: 'blur'
					}],
					password: [{
						validator: checkAge,
						trigger: 'blur'
					}]
				},
				formInline: {
					user: '',
					region: '',
					time: ''
				},
				tableData: [],
				tableData4: [],
				centerDialogVisible: false,
				centerDialogVisible2: false,
				title:'添加员工',
				allpage:0,//数据总数
				eachPage:10,//每页
				indexPage:1,//当前页	
				disabledStatus:false
			}
		},
		methods: {
			handleSizeChange(val) { //console.log(`每页 ${val} 条`);
				this.eachPage = val;
				this.tableData4 = this.tableData.slice(0, this.eachPage);
			},
			handleCurrentChange(val) { //console.log(`当前页: ${val}`);
				this.indexPage = val;
				this.tableData4 = this.tableData.slice(this.eachPage * (this.indexPage - 1), this.eachPage * this.indexPage);
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
				console.log(val)
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.addsub()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			addsub(){
				var data={};
				var arr=[];
				var pids='';
				for(var item in this.ruleForm3){
					arr.push({'status':this.ruleForm3[item]})
				}
				arr.forEach((item,index) => {
					item.id=index+1;
					if(item.status){
						pids+='pids='+item.id+'&'
					}
				})
				console.log(arr)
				if(this.title == '添加员工'){
					data={
						name:this.ruleForm2.name,
						passport:this.ruleForm2.passport,
						password:this.ruleForm2.password
					}					
				}else{
					data={
						name:this.ruleForm2.name,
						passport:this.ruleForm2.passport,
						password:this.ruleForm2.password,
						id:this.ruleForm2.id
					}
					if(data.password != '' && data.password.toString().length < 6){
						return this.$message.warning('密码不能小于6位')
					}
				}
				addsub(data,pids)
				.then( res => {
					console.log(res)
					if(res.data.code == 0){
						var message=''
						if(this.title == '添加员工'){
							message='恭喜你，添加人员成功！'
						}else{
							message='恭喜你，修改人员成功！'
						}
						this.$message({
						  showClose: true,
						  message,
						  type: 'success'
						});
						this.centerDialogVisible=false;
						this.getData()
					}else if(res.data.code == 105013){
						this.$message.warning('该员工已存在！')
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			getData(){
				var data={
					start:0,
					count:200
				}
				listsubBySetter(data)
				.then( res => {
					if(res.data.code == 0){
						console.log(res.data.obj,'238')
						this.tableData=res.data.obj;
						this.allpage=this.tableData.length;
						this.handleSizeChange(this.eachPage);
						this.tableData.forEach(item => {
							item.user.password='';
						})
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			deleteFun(){
				var data={
					subId:this.ruleForm2.user.id
				}
				delsub(data)
				.then( res => {
					if(res.data.code == 0){
						this.$message({
						  showClose: true,
						  message:'删除成功！',
						  type: 'success'
						});
						this.centerDialogVisible2=false;
						this.getData()
					}
				})
				.catch(err => {
					console.log(err)
				})				
			},
			addPermissionFun(){
				var arr=[];
				var pids='';
				for(var item in this.ruleForm3){
					arr.push({'status':this.ruleForm3[item]})
				}
				arr.forEach((item,index) => {
					item.id=index+1;
					if(item.status){
						pids+='pids='+item.id+'&'
					}
				})
				var data={
					userId:this.pidsData.id
				}
				addPermission(data,pids)
				.then(res => {
					console.log(res);
					if(res.data.code == 0){
						this.$message({
						  showClose: true,
						  message:'权限设置成功！',
						  type: 'success'
						});	
						this.centerDialogVisible1=false					
					}
				})
				.catch(err => {
					console.log(err)
				})
			},
			setruleForm3(data){
				data.forEach((item,index) => {
					this.ruleForm3['value'+ (index+1)]=item.check;
				})
				if(this.ruleForm2.level == 0){
					this.disabledStatus=true
				}else{
					this.disabledStatus=false
				}
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>
<style>
	.has-gutter th {
		background-color: #f5f7fb;
	}
	.el-switch{margin-right: 20px;}
</style>
<style scoped="scoped">
	h3 {
		margin: 20px 0;
		font-weight: normal;
	}

	.searchBox {
		margin-top: 20px;
	}

	.table {
		margin-top: 20px;
	}

	.fenye {
		margin-top: 20px;
		overflow: hidden;
	}

	.fenye .pagination {
		float: right;
	}
</style>



// WEBPACK FOOTER //
// src/views/setting/peopleSetting.vue